import React, { Component } from 'react';

class CountdownTimer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            timeRemaining: this.props.seconds,
        };

        this.tick = this.tick.bind(this);
        this.formatTime = this.formatTime.bind(this);
    }

    componentDidMount() {
        this.interval = setInterval(this.tick, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    tick() {
        this.setState((prevState) => {
            if (prevState.timeRemaining > 0) {
                return { timeRemaining: prevState.timeRemaining - 1 };
            } else {
                clearInterval(this.interval);
                if (this.props.onComplete) {
                    this.props.onComplete();
                }
                return { timeRemaining: 0 };
            }
        });
    }

    formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
    }

    render() {
        return (
            <div className={"text-center pb-3"}>
                <small className={"text-danger"}>남은 시간 : {this.formatTime(this.state.timeRemaining)}</small>
            </div>
        );
    }
}

export default CountdownTimer;
